import React from "react";
import {BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, Tooltip, LabelList} from "recharts";

const SubscalePlots = ({ theme, subscaleScores }) => {
    if (!theme || !subscaleScores || subscaleScores.length === 0) return null;

    // 🎨 Define Theme-Based Colors
    const themeColors = {
        "Investigative": "#DC143C",  // Red
        "Realistic": "#9370DB",      // Purple
        "Conventional": "#FFA500",   // Orange
        "Social": "#90EE90",         // Light Green
        "Artistic": "#FF7F50",       // Coral
        "Enterprising": "#87CEEB",   // Sky Blue
    };

    // 🎨 Generate a color gradient for subscales based on the theme
    const subscaleColors = subscaleScores.map(() => {
        return themeColors[theme] || "#999";
    });

    return (
        <ResponsiveContainer width="100%" height={subscaleScores.length * 50}>
            <BarChart layout="vertical" data={subscaleScores} margin={{ top: 1, right: 30, left: 30, bottom: 1 }}>
                <XAxis type="number" domain={[0, 100]} tick={{ fill: "#ffffff" }} />
                <YAxis type="category" dataKey="subscale" tick={{ fill: "#ffffff" }} width={160} />
                <Tooltip cursor={{ fill: "rgba(255, 255, 255, 0.1)" }} />
                <Bar dataKey="score">
                    {subscaleScores.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={subscaleColors[index]} />
                    ))}
                    <LabelList
                        dataKey="score"
                        position="right"
                        fill="white"
                        fontSize={14}
                        formatter={(value) => Math.round(value)}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default SubscalePlots;
